import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const SystemGeneratedInfo = ({ label, infoText }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div onClick={() => setShowModal(true)} style={{ cursor: 'pointer', display: 'inline-block' }}>
                <img src="/mdi_eye-outline.png" alt="View Info" style={{ width: '15px', height: '15px' }} />
            </div>

            {showModal && createPortal(
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 }}>
                    <div className="bg-white rounded-4 shadow p-4" style={{ width: '600px', maxWidth: '95%' }}>
                        {/* Header */}
                        <div className="d-flex justify-content-center position-relative mb-4">
                            <h4 className="fw-bold mb-0">{label}</h4>
                            <button
                                onClick={() => setShowModal(false)}
                                className="btn-close position-absolute top-0 end-0"
                                aria-label="Close"
                                style={{ fontSize: '1.2rem' }}
                            ></button>
                        </div>

                        {/* Body */}
                        <div className="mb-3 text-start">
                            <label className="form-label fw-semibold">System-generated</label>
                            <div className="py-2 px-3 rounded" style={{ backgroundColor: '#f8f9fa', color: '#495057', border: '1px solid #ced4da' }}>
                                {infoText}
                            </div>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default SystemGeneratedInfo;
